import {
    SIDEBAR_LEFT_SHOW,
    SIDEBAR_LEFT_HIDE,
    SIDEBAR_RIGHT_SHOW,
    SIDEBAR_RIGHT_HIDE,

    SIDEBAR_HIDE_ALL
} from '../constants/sidebars';

import {
    ROOM_SWITCHED
} from '../constants/rooms';

import {
    PM_WINDOW_MAXIMIZE
} from '../constants/pm';

export default function sidebars(state = {leftShown: undefined, rightShown: undefined}, action) {
    if (action.type === SIDEBAR_LEFT_SHOW && !state.leftShown) return {...state, leftShown: true };
    if (action.type === SIDEBAR_LEFT_HIDE && state.leftShown) return {...state, leftShown: false };

    if (action.type === SIDEBAR_RIGHT_SHOW && !state.rightShown) return {...state, rightShown: true };
    if (action.type === SIDEBAR_RIGHT_HIDE && state.rightShown) return {...state, rightShown: false };

    if (action.type === SIDEBAR_HIDE_ALL) return {leftShown: false, rightShown: false};

    if (
        [ROOM_SWITCHED, PM_WINDOW_MAXIMIZE].indexOf(action.type) != -1 &&
        action.browser.mobile
    ) {
        return {...state, leftShown: false};
    }


    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/sidebars.js